import axios from 'axios';

const FASTAPI_URL = process.env.REACT_APP_API_URL;
const FASTAPI_WEBHOOK_DEST_URL = process.env.REACT_APP_FASTAPI_WEBHOOK_DEST_URL;
const INSTANCE_WEBHOOK_EVENTS = [
    'CONNECTION_UPDATE',
    'GROUPS_UPSERT',
    'GROUP_PARTICIPANTS_UPDATE',
];

export function buildWebhookConfig() {
    return {
        enabled: true,
        url: `${FASTAPI_WEBHOOK_DEST_URL}`,
        headers: {
            authorization: 'Bearer TOKEN',
            'Content-Type': 'application/json',
        },
        byEvents: true,
        webhookByEvents: true,
        webhookBase64: false,
        events: INSTANCE_WEBHOOK_EVENTS,
    };
}

export function buildInstanceCreatePayload(instanceId) {
    return {
        instanceName: instanceId,
        qrcode: true,
        integration: 'WHATSAPP-BAILEYS',
        webhook_by_events: true,
        webhookBase64: false,
        //rabbitmq: {
        //    enabled: true,
        //    events: ['MESSAGES_UPSERT'],
        //},
    };
}

export async function createWebHooks(instanceId) {
    const destUrl = `${FASTAPI_URL}/api/webhook/set/${encodeURIComponent(instanceId)}`;

    const data = {};

    try {
        const response = await axios.post(destUrl, data, {
            headers: { 'Content-Type': 'application/json' }
        });

        if (response.data && response.data.events) {
            console.log("Webhook created successfully:", response.data);
            return response.data;
        } else {
            console.warn("Unexpected response from server:", response.data);
            throw new Error("Webhook creation unsuccessful: Invalid response structure.");
        }
    } catch (error) {
        console.error(`Error creating webhook for instance ${instanceId}:`, error);
        throw error;
    }
};

//Not needed
/*export async function createRabbitMqSubscription(instanceId) {
    const destUrl = `${NODE_API_URL}/rabbitmq/set/${instanceId}`;

    const data = {
        enabled: true,
        events: ["MESSAGES_UPSERT"]
    };

    try {
        const response = await axios.post(destUrl, data, {
            headers: {
                apikey: 'BQYHJGJHJ',
                'Content-Type': 'application/json'
            }
        });

        if (response.data && response.data.success) {
            console.log("RabbitMQ subscription created successfully:", response.data);
            return response.data;
        } else {
            console.warn("Unexpected response from server:", response.data);
            throw new Error("RabbitMQ subscription unsuccessful: Invalid response structure.");
        }
    } catch (error) {
        console.error(`Error creating RabbitMQ subscription for instance ${instanceId}:`, error);
        throw error;
    }
}*/
